import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';

import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import {
  createFiledLien,
  getSupplierFiledLiens,
  getFiledLien,
  updateFiledLien,
  deleteFiledLien,
} from '../services/filedLiensService';
import { FiledLienInitialState } from '../globalSlices/filedLiensSlice';

export const createFiledLienExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienInitialState>
) => {
  const reducerId = 'createFiledLien';
  builder.addCase(createFiledLien.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    createFiledLien.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(createFiledLien.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const getSupplierFiledLiensExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienInitialState>
) => {
  const reducerId = 'getSupplierFiledLiens';
  builder.addCase(getSupplierFiledLiens.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.loadingErrorList = [];
  });
  builder.addCase(getSupplierFiledLiens.fulfilled, (state, action: PayloadAction<any | null>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload?.success && action.payload.data) {
      state.filedLiens = action.payload.data;
    }
  });
  builder.addCase(getSupplierFiledLiens.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload) {
      state.loadingErrorList = [
        ...new Set([...state.loadingErrorList, { getSupplierFiledLiens: action.payload }]),
      ];
    }
  });
};

export const getFiledLienExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienInitialState>
) => {
  const reducerId = 'getFiledLien';
  builder.addCase(getFiledLien.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
    state.loadingErrorList = [];
    state.selectedFiledLien = null;
  });
  builder.addCase(
    getFiledLien.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
      if (action.payload && action.payload.success && action.payload.data) {
        state.selectedFiledLien = action.payload.data;
      }
    }
  );
  builder.addCase(getFiledLien.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    if (action.payload) {
      state.loadingErrorList = [
        ...new Set([...state.loadingErrorList, { getFiledLien: action.payload }]),
      ];
    }
  });
};

export const updateFiledLienExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienInitialState>
) => {
  const reducerId = 'updateFiledLien';
  builder.addCase(updateFiledLien.pending, (state, action) => {
    if (!action.meta.arg?.isHideLoadingIndicator) {
      state.loadingList = [...new Set([...state.loadingList, reducerId])];
    }
  });
  builder.addCase(
    updateFiledLien.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(updateFiledLien.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};

export const deleteFiledLienExtraReducer = (
  builder: ActionReducerMapBuilder<FiledLienInitialState>
) => {
  const reducerId = 'deleteFiledLien';
  builder.addCase(deleteFiledLien.pending, (state, action) => {
    state.loadingList = [...new Set([...state.loadingList, reducerId])];
  });
  builder.addCase(
    deleteFiledLien.fulfilled,
    (state, action: PayloadAction<AppServerResponse | null>) => {
      state.loadingList = state.loadingList.filter((item) => item !== reducerId);
    }
  );
  builder.addCase(deleteFiledLien.rejected, (state, action: PayloadAction<any>) => {
    state.loadingList = state.loadingList.filter((item) => item !== reducerId);
  });
};
